import { Funcionario } from "../../models/funcionario";
import { IGetFuncionarioByIdUseCase } from "../../../presentation/useCases/read/get_funcionario_by_id_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetFuncionarioByIdUseCase
 */

export class GetFuncionarioByIdUseCase implements IGetFuncionarioByIdUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async getFuncionarioById(idFuncionario: number): Promise<Funcionario | null> {
    return await this.repository.getFuncionarioById(idFuncionario);
  }
}